import { Pass, Seq, Cont, Dep, setObjectValue } from "../../framework/Processes";
import { Application, External } from "../../framework/comp/Lambda/Constructors";
import { FunctionType } from "../../framework/comp/Types";
import MultivariateFunction from "../../framework/comp/EInstances/MultivariateFunction";
import MinigamesConfig from "../MinigamesConfig";

let RunMinigameProcess, RunAtomicTask;
import("./RunMinigameProcess").then(val => { RunMinigameProcess = val.default; RunAtomicTask = val.RunAtomicTask }).catch(val => console.error(val));

/**
 * Constructor of process produces a menu array as form and continues as RunMinigameProcess.
 * @param {[{ name: string, title: string }]} menu - menu array
 * @param runningProcess - process running in parallel
 */
function MenuProcess(menu, runningProcess) {
	return Cont("Player", { type: "Menu", menu }, External(function(taskName) {
		return Seq([
			setObjectValue("prcType", "menu"),
			Dep(Application(MultivariateFunction(MenuToGoFunc, 2, ["String", "Object"], "Process"), External(taskName, "String"))),
			runningProcess,
		]);
	}, "Function", FunctionType("Object", "Process")));
}

function MenuToGoFunc(taskName, state) {
	const task = MinigamesConfig.getMinigameByName(taskName);
	return RunAtomicTask(task);
}

export default MenuProcess;